<div class="actions-container">
  <ng-casto-button [label]="'need_mapping.no_choice.info'|translate" class="secondary"
                   (click)="selectModel(0)"></ng-casto-button>
</div>
<ul class="inspiration-items">
  @for (model of models; track model) {
    <li [class.active]="current.kitchen.modelId === model.id">
      <figure (click)="selectModel(model.id)">
      <span class="media">
        <img *ngIf="model.img !== ''" [src]="'assets/img/' + model.img" [alt]="model.title" />
        <span class="title-overlay">
   {{ model.title | translate }}
  </span>
        <span class="state">
          <svg class="icon-action-select-thumb" aria-hidden="true">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
          </svg>
        </span>
      </span>
      </figure>
    </li>
  }

</ul>
